import { queryAll } from './dom.js';

/**
 * Contact Preferences chips.
 *
 * Each chip is a <label> wrapping a real (visually hidden) checkbox, so the
 * group posts with the form and the browser handles keyboard interaction.
 * This module owns the visual side of that: it mirrors each checkbox's
 * checked state onto its chip as `.is-selected`, which is what draws the
 * selected border and reveals the close glyph.
 *
 * It also tracks the selection against the state the page loaded with, so the
 * Save button only becomes available once something has actually changed —
 * and goes back to disabled if the user undoes their way to the original set.
 */
export function initAccountPreferences() {
  const form = document.querySelector('[data-preferences-form]');
  if (!form) return;

  const inputs = queryAll('[data-action="toggle-preference"]', form);
  if (!inputs.length) return;

  const saveButton = form.querySelector('[data-action="save-preferences"]');

  // Snapshot of what the server rendered. Inputs are read in DOM order, so
  // two selections match when their value lists match position for position.
  const initial = selected().join('|');

  function selected() {
    return inputs.filter(input => input.checked).map(input => input.value);
  }

  function chipOf(input) {
    return input.closest('.myaccount-preferences__chip');
  }

  function paint(input) {
    const chip = chipOf(input);
    if (chip) chip.classList.toggle('is-selected', input.checked);
  }

  function refresh() {
    if (saveButton) saveButton.disabled = selected().join('|') === initial;
  }

  inputs.forEach(input => {
    // Re-assert on load: a bfcache restore or a browser-remembered form state
    // can leave the checkbox and its chip disagreeing.
    paint(input);

    input.addEventListener('change', () => {
      paint(input);
      refresh();
      form.dispatchEvent(new CustomEvent('preferences:change', {
        bubbles: true,
        detail: { selected: selected() }
      }));
    });
  });

  refresh();
}
